import moment from 'moment';
import config from './../config';

const AuthHelper = {
	isAuthenticated() {
		const jsonData = JSON.parse(localStorage.getItem('cso_transport_booking_app'));
		if (!jsonData) {
			return false;
		}

		const { token, last_login } = jsonData;
		const now = moment();

		// add back token if api is ready
		if (last_login) {
			const tokenLifeInSeconds = now.diff(moment(last_login), 'seconds');
			return tokenLifeInSeconds < config.loginTimeout;
		}

		return false;
	}
};

export default AuthHelper;
